import React from "react";
import "./Profile.scss";

import { withFirebase } from "components/Firebase";
import { compose } from "recompose";

import ProfileSidebar from "components/ProfileSidebar";
import ProfileGallery from "components/ProfileGallery";

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      loaded: false,
      user: {
        firstName: "",
        lastName: "",
        description: "",
        location: "",
        userName: "",
        picture: null
      },
      isMyProfile: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.key !== prevProps.location.key) {
      this.setState({ loaded: false, projects: [] });
      this.loadProfile();
    }
  }

  componentDidMount() {
    this.loadProfile();
  }

  loadProfile = () => {
    const projects = [];
    let { user } = this.state;

    this.props.firebase
      .userByUsername(this.props.match.params.username)
      .then(response => {
        user = { ...response.docs[0].data() };
        user.id = response.docs[0].id;
        this.setState({ user });

        this.props.firebase
          .projectsByUser(this.state.user.id)
          .get()
          .then(({ docs }) => {
            this.props.firebase
              .getCurrentUser()
              .then(response => {
                if (this.state.user.id === response.uid) {
                  this.setState({ isMyProfile: true });

                  if (docs.length === 0) {
                    this.props.history.push("/create-project");
                  }
                } else {
                  if (docs.length === 0) {
                    this.props.history.push("/");
                  }
                }
              })
              .catch(console.error);

            docs.map((doc, i) => {
              projects.push(doc.data());
              this.setState({
                projects
              });

              setTimeout(
                () =>
                  this.setState({
                    loaded: true
                  }),
                125
              );
              return true;
            });
          })
          .catch(console.error);
      })
      .catch(error => {
        this.props.history.push("/");
      });
  };

  render() {
    const { user, projects, isMyProfile, loaded } = this.state;
    return (
      <div className="Profile">
        <ProfileSidebar loaded={loaded} isMyProfile={isMyProfile} user={user} />
        <ProfileGallery projects={projects} />
      </div>
    );
  }
}

export default compose(withFirebase)(Profile);
